import React from "react";
import Header from "components/header/Header";
import Footer from "components/footer/Footer";
import type { Theme } from "types";

interface PageLayoutProps {
  children: React.ReactNode;
  theme: Theme;
  setTheme?: React.Dispatch<React.SetStateAction<string>>;
}

export function PageLayout({
  children,
  theme,
  setTheme,
}: Readonly<PageLayoutProps>) {
  return (
    <div className="portfolio-shell min-h-screen overflow-x-hidden bg-bg-primary text-text-primary transition-theme">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[60] focus:rounded-md focus:bg-accent focus:px-4 focus:py-2 focus:text-bg-primary focus:shadow-lg"
      >
        Skip to content
      </a>
      <Header theme={theme} setTheme={setTheme} />
      <main
        id="main-content"
        className="relative z-10 max-w-6xl mx-auto px-4 pt-20 pb-14 sm:px-6 md:pt-24 md:pb-16 lg:px-8 lg:pt-28 lg:pb-20"
      >
        {children}
      </main>
      <Footer theme={theme} />
    </div>
  );
}
